import {useState} from 'react';
import Spinner from 'react-bootstrap/Spinner';

function LoadingScreen() {
  const [show, setShow] = useState(true);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <div className='container py-5 text-center loading-container'>
      <img src='loading.svg' className='wiggle d-inline-block' />
      <Spinner animation='border' role='status'></Spinner>
      <h5 className='text-center my-3'>
        We are now customising your content...
      </h5>
    </div>
  );
}

export default LoadingScreen;
